import axios from "axios";

export default class ItemRAPI {
    static async setWarehouse(itemId: number, rack: string, shelf: string) {
        return (await axios.post('items/' + itemId + '/warehouse/', {
            rack: rack,
            shelf: shelf
        })).data
    }
    static async setIssue(itemId: number, code: string) {
        return (await axios.post('items/' + itemId + '/issue/', {
            code: code
        })).data
    }
    static async returnWarranty(itemId: number) {
        return (await axios.post('items/' + itemId + '/return_warranty/')).data
    }
    static async setFreeze(itemId: number) {
        return (await axios.post('items/' + itemId + '/freeze/')).data
    }
    static async addItem(Item: any) {
        return (await axios.post('items/', Item)).data
    }
    static async setDesire(itemId: number, date: string, comment: string) {
        return (await axios.post('items/' + itemId + '/desire/', {
            date: date,
            comment: comment
        })).data
    }
    static async getTicket(itemId: number) {
        return (await axios.post('items/' + itemId + '/print_ticket/')).data
    }
    static async setComment(itemId: number, comment: string) {
        return (await axios.post('items/' + itemId + '/comment/', {
            comment: comment
        })).data
    }
    static async delete(itemId: number) {
        return (await axios.post('items/' + itemId + '/delete/')).data
    }

    static async setPrice(itemId: number, price: number) {
        return (await axios.post('items/' + itemId + '/price/', {
            price: price
        })).data
    }
    static async setNeedShoeLast(itemId: number, need: boolean) {
        return (await axios.post('items/' + itemId + '/need_shoelast/', {
            need: need
        })).data
    }
}